import { SET_CONTACT_MODAL } from '../types'

const reducer = (state, action) => {
  switch (action.type) {
    case SET_CONTACT_MODAL:
      return {
        ...state,
        contactModal: action.payload,
      }
    default:
      return state
  }
}

export default reducer
